import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import uuid from 'uuid'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'
import { Modal } from 'containers/misc'
import { TaskApprove, TaskReturn } from 'containers/forms/tasks'
import { Table, Data } from 'components/layout/Table'
import { Button, ButtonGroup } from 'components/misc'
import { AssessorDetailModal } from 'components/modals'
import MODALS from 'constants/modals'
import { tasks as tasksLayout } from 'constants/layout'
import {
  apiActivities,
  apiCodeLists,
  apiCommon,
  apiConfiguration,
  apiTasksRegistrationParticipants,
  apiParticipants,
  apiAwards,
  apiTasksAssessors,
  apiAssessors
} from 'helpers/decorators/api'
import { modal, notification } from 'redux/modules/app'
import { meta, tableCommon } from 'helpers/decorators'
import { Link } from 'react-router-dom'
import config from '../../../config'
import TaskAssessorEdit from '../../forms/tasks/TaskAssessorEdit/TaskAssessorEdit'
import { CONFIGURATION_KEYS } from '../../../constants/enums'


@meta({
  title: 'Tasks - Assessor Activity Category Registration',
  intlKey: 'pageTitle.tasks_assessors_activity_category_registration'
})
@apiTasksRegistrationParticipants({
  participants: true
})
@apiParticipants({
  updateTasks: true
})
@apiTasksAssessors({
  assessorActivityCategoryTasks: true,
  updateTasks: true,
  useCommonLimit: true
})
@apiAwards({
  updateRegistrationTasks: true
})
@apiAssessors()
@apiConfiguration({
  getValues: [
    CONFIGURATION_KEYS.manageAssessors.id
  ],
  inOrganizationDetail: true
})
@apiCommon({
  countries: true,
})
@apiCodeLists(['titles', 'phoneTypes', 'assessorReasonsOfDeletionTypes', 'activitySections'])
@apiActivities({
    activityCategories: true
})
@tableCommon()
@connect(
    ({ api }) => ({
      assessors: api.assessors
    }),
    { modal, notification }
)
class TasksAssessorsActivityCategoryRegistrations extends Component {
  static propTypes = {
    tasksAssessors: PropTypes.object.isRequired,
    modal: PropTypes.func.isRequired,
    setAssessorTasksParams: PropTypes.func,
    onApproveActivityCategoryRegistration: PropTypes.func.isRequired,
    onReturnActivityCategoryRegistration: PropTypes.func.isRequired,
    setCommonLimit: PropTypes.func,
    configuration: PropTypes.object.isRequired,
    codeLists: PropTypes.object.isRequired,
    common: PropTypes.object.isRequired,
    activities: PropTypes.object.isRequired,
    assessors: PropTypes.object.isRequired,
    onUpdateActivityRegistration: PropTypes.func.isRequired,
    onDeleteActivityRegistration: PropTypes.func.isRequired,
    onGetActivityCategoryRegistrationFiles: PropTypes.func.isRequired
  }

  state = {
    regId: null,
    assessorRegistration: null,
    registrationFiles: []
  }

  key = uuid.v1()

  handleApproveModal = regId => {
    this.setState({ regId },
      () => {
        this.props.modal(`modal-approve-${this.key}`)
      }
    )
  }

  handleReturnModal = asessorRegistrationId => {
    this.setState(
      {
        asessorRegistrationId
      },
      () => {
        this.props.modal(`modal-return-${this.key}`)
      }
    )
  }

  handleShowAssessorDetails = assessorRegistration => {
    this.setState({ assessorRegistration }, () => {
      this.props.modal(MODALS.ASSESSOR_REGISTRATION_DETAIL)
    })
  }

  getActivityCategory = registration => {
    if (get(registration, 'activity')) {
      return get(registration, 'activity.activityCategory.translatedName')
    }

    if (get(registration, 'activityCategory')) {
      return get(registration, 'activityCategory.translatedName')
    }

    if (get(registration, 'ajEvent')) {
      return get(registration, 'ajEvent.activityCategory.translatedName')
    }

    if (get(registration, 'residentialProject')) {
      return get(registration, 'residentialProject.activityCategory.translatedName')
    }
  }

  getActivitySection = registration => {
    if (get(registration, 'activity')) {
      return get(registration, 'activity.activitySection.translationText')
    }

    if (get(registration, 'activityCategory')) {
      return get(registration, 'activityCategory.activitySection.translationText')
    }


    if (get(registration, 'ajEvent')) {
      return get(registration, 'ajEvent.ajEventCategory.translationText')
    }

    if (get(registration, 'residentialProject')) {
      return get(registration, 'residentialProject.activitySection.translationText')
    }
  }

  handleEditModal = async assessorRegistration => {
    await this.props.onGetActivityCategoryRegistrationFiles(get(assessorRegistration, 'id'))

    this.setState({ assessorRegistration, registrationFiles: get(this.props, 'assessors.registrations.files.list') }, () => {
      this.props.modal(MODALS.ASSESSOR_REGISTRATION_EDIT)
    })
  }

  render() {
    const {
      tasksAssessors,
      setAssessorTasksParams,
      onApproveActivityCategoryRegistration,
      onReturnActivityCategoryRegistration,
      setCommonLimit,
      configuration,
      codeLists,
      common,
      activities,
    } = this.props

    const loading = get(tasksAssessors, 'activityCategoryRegistration.loading')
    const list = get(tasksAssessors, 'activityCategoryRegistration.list')
    const offset = get(tasksAssessors, 'activityCategoryRegistration.offset')
    const limit = get(tasksAssessors, 'activityCategoryRegistration.limit')
    const pages = get(tasksAssessors, 'activityCategoryRegistration.pages')
    const sort = get(tasksAssessors, 'activityCategoryRegistration.sort')

    const isAssessorManagementEnabled = configuration && configuration.values[CONFIGURATION_KEYS.manageAssessors.id]?.booleanValue

    return (
      <div>
        <Table
          loading={loading}
          length={list.length}
          offset={offset}
          limit={limit}
          onSetLimit={setCommonLimit}
          pages={pages}
          sort={sort}
          ths={tasksLayout.assessorActivityCategoryRegistration}
          setParams={setAssessorTasksParams}
        >
          <Data>
            {list.map(({ assessorActivityCategoryRegistration, id }) => (

              <tr key={id}>
                <td>
                  <Link to={`${config.publicPath}/organizations/${get(assessorActivityCategoryRegistration, 'assessor.organization.id')}/assessors/${get(assessorActivityCategoryRegistration, 'assessor.person.id')}/detail`}>
                    {get(assessorActivityCategoryRegistration, 'assessor.id')}
                  </Link>
                </td>
                <td>{get(assessorActivityCategoryRegistration, 'assessor.person.firstName')}</td>
                <td>{get(assessorActivityCategoryRegistration, 'assessor.person.lastName')}</td>
                <td>{this.getActivitySection(assessorActivityCategoryRegistration)}</td>
                <td>{this.getActivityCategory(assessorActivityCategoryRegistration)}</td>
                <td>
                  <span>
                    {get(assessorActivityCategoryRegistration, 'invitedBy.firstName') || '---'}{' '}
                    {get(assessorActivityCategoryRegistration, 'invitedBy.lastName') || '---'}
                    <br />
                    {get(assessorActivityCategoryRegistration, 'invitedBy.participantDetail.id') ?
                      <Link to={`${config.publicPath}/participants/${get(assessorActivityCategoryRegistration, 'invitedBy.id')}`}>
                        {get(assessorActivityCategoryRegistration, 'invitedBy.globalId') || '---'}
                      </Link> :
                      <FormattedMessage id="label.award_leader" defaultMessage="Award Leader" /> }
                  </span>
                </td>
                <td>
                  {get(assessorActivityCategoryRegistration, 'assessor.organization.name')}
                </td>
                <td>
                  <Button
                    style={{ marginLeft: 10 }}
                    onClick={() => this.handleEditModal(assessorActivityCategoryRegistration)}
                    tiny
                    secondary
                  >
                    <FormattedMessage
                      id="button.confirm"
                      defaultMessage="Confirm"
                    />
                  </Button>
                </td>
                <td>
                  <ButtonGroup>
                    <Button
                      onClick={() =>
                        this.handleApproveModal(assessorActivityCategoryRegistration.id)
                      }
                      tiny
                    >
                      <FormattedMessage
                        id="button.approve"
                        defaultMessage="Approve"
                      />
                    </Button>
                  </ButtonGroup>
                </td>
              </tr>
            ))}
          </Data>
        </Table>
        <Modal id={MODALS.ASSESSOR_REGISTRATION_EDIT} customActions large>
          <TaskAssessorEdit
            registration={this.state.assessorRegistration}
            registrationFiles={this.state.registrationFiles}
            forActivityRegistration
            isAssessorManagementEnabled={isAssessorManagementEnabled}
            codeLists={codeLists}
            common={common}
            activities={activities}
            onEditSubmit={this.props.onUpdateActivityRegistration}
            onDeleteSubmit={this.props.onDeleteActivityRegistration}
          />
        </Modal>
        <Modal id={`modal-approve-${this.key}`} customActions>
          <TaskApprove
            approve={onApproveActivityCategoryRegistration}
            id={this.state.regId}
            modal={this.props.modal}
            title="Approve assessor activity registration"
            intlKey="tasks.approve_assessor_activity_registration"
          />
        </Modal>
        <Modal id={`modal-return-${this.key}`} customActions>
          <TaskReturn
            returnTask={onReturnActivityCategoryRegistration}
            id={this.state.regId}
            modal={this.props.modal}
          />
        </Modal>
        {this.state.assessorRegistration && (
          <AssessorDetailModal
            modalId={MODALS.ASSESSOR_REGISTRATION_DETAIL}
            data={this.state.assessorRegistration}
            modal={this.props.modal}
          />
        )}
      </div>
    )
  }
}

export default TasksAssessorsActivityCategoryRegistrations
